module.exports = __webpack_public_path__ + "static/sanfranciscodisplay-regular-webfont-578fb8973c77ca5f3cd54f4a44390d37.woff";